import React, { FC, useMemo, useRef } from 'react';
import JoditEditor from 'jodit-react';
import Required from '../required/Required';
import style from './index.module.scss';

type TProps = {
  onValueChange: (val: string) => void;
  content?: string;
  title: string;
};

const NewsEditor: FC<TProps> = ({ onValueChange, content, title }) => {
  const editor = useRef(null);

  const config = useMemo(() => {
    return {
      readonly: false,
      placeholder: 'Начните писать...',
      // uploader: {
      //   insertImageAsBase64URI: true,
      //   imagesExtensions: ['jpg', 'png', 'jpeg', 'gif', 'svg', 'webp'],
      // },
      speechRecognize: {
        lang: 'ru',
      },
      addNewLine: false,
      autofocus: true,
      toolbarAdaptive: true,
      hidePoweredByJodit: true,
      removeButtons: [
        'speechRecognize',
        'about',
        'classSpan',
        'source',
        'copyformat',
        'video',
        'file',
        'ai-assistant',
        'ai-commands',
      ],
      sourceEditorCDNUrlsJS: ['./node_modules/ace-builds/src-min/ace.js'],
      beautifyHTMLCDNUrlsJS: [
        './node_modules/js-beautify/js/lib/beautify.js',
        './node_modules/js-beautify/js/lib/beautify-html.js',
      ],
    };
  }, []);

  return (
    <div className={style.text}>
      <h3>
        <Required>{title}</Required>
      </h3>
      <JoditEditor ref={editor} value={content || ''} config={config} onChange={onValueChange} />
    </div>
  );
};

export default NewsEditor;
